export default __webpack_public_path__ + "static/media/fl.aa80c221.png";